<template>
    <div>
        <!-- 日报 -->
        <div class="timeAll" v-if="timeIndex == 0">
            <!-- 日报左边模块 -->
            <div class="left">
                <div>
                    {{ todayDate[1] }}月
                </div>
                <div>
                    {{ todayDate[0] }}年
                </div>
            </div>
            <!-- 日报右边模块 -->
            <div class="right">
                <div :class="index == isIndex ? 'table_header  active' : 'table_header'" v-for="item, index in dateList"
                    :key="index" @click="getItem(item, index)">
                    <div class="weekday">
                        <span>{{ item.date.split("-")[2] }} </span>
                    </div>
                    <div class="weekday">
                        <span>{{ item.week }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 周报 -->
        <div class="timeAll" v-if="timeIndex == 1">
            <div v-for="item, index in week3List" :key="index" :class="isIndex2 == index ? 'week3 week3-active' : 'week3'" @click="week3Change(item,index)">
                <div>{{ item.start }}</div>
                <div>至</div>
                <div>{{ item.end }}</div>
            </div>
        </div>
        <!-- 月报 -->
        <div class="timeAll" v-if="timeIndex == 2">
            <div v-for="item, index in monthList" :key="index" :class="isIndex3 == index ? 'week3 week3-active' : 'week3'" @click="monthChange(item,index)">
                <div>{{ item.year }}</div>
                <div>{{ item.month }}</div>
            </div>
        </div>
    </div>

</template>
<script>
import moment from "moment"
export default {
    data() {
        return {
            // 日报年月
            todayDate: "",
            // 日报切换索引 默认最近日期
            isIndex: 3,
            // 日报 周几和日期
            dateList: [],
            // 周报最近三周
            week3List: [],
            // 周报切换索引 默认最近日期
            isIndex2: 2,
            // 月报最近三个月
            monthList:[],
            // 月报切换索引 默认最近日期
            isIndex3: 2,
        }
    },
    props: {
        // 父组件传递切换显示 日/周/月报
        timeIndex: {
            type: Number,
            default: 0
        }
    },
    created() {
        // 获取最近四天 周几和日期
        for (var i = 0; i < 4; i++) {
            let date = moment().subtract(i, 'day').format('YYYY-MM-DD')
            this.dateList.unshift(
                {
                    date: date,
                    week: this.getWeek(date)
                }
            )
        }
        this.todayDate = this.dateList[3].date.split('-')

        // 获取最近三个月
        for (var i = 0; i < 3; i++) {
            let date = moment().subtract(i, 'month').format('YYYY-MM').split('-')
            this.monthList.unshift(
                {
                    month: date[1],
                    year: date[0]
                }
            )
        }

        // 获取最近三周
        let week = 3 
        let weekOfDay = new Date().getDay() // 今天星期几
        for (let i = 0; i < week; i++) {
            this.week3List.unshift({
                start: moment().subtract(weekOfDay + 7 * i - 1, 'days').format('YYYY-MM-DD'),
                end: moment().subtract(weekOfDay + 7 * (i - 1), 'days').format('YYYY-MM-DD')
            })
        }
    },
    methods: {
        // 判断周几
        getWeek(date) {
            const week = moment(date).day();
            switch (week) {
                case 1:
                    return '一';
                case 2:
                    return '二';
                case 3:
                    return '三';
                case 4:
                    return '四';
                case 5:
                    return '五';
                case 6:
                    return '六';
                case 0:
                    return '日';
            }
        },
        // 切换日报
        getItem(item, index) {
            this.todayDate = this.dateList[index].date.split('-')
            this.isIndex = index
            this.$emit('getItem', item)
        },
        // 切换周报
        week3Change(item,index){
            this.isIndex2 = index
            this.$emit('getItem2', item)
        },
        // 切换月报
        monthChange(item,index){
            this.isIndex3 = index
            this.$emit('getItem3', item)
        }
    },
}
</script>
<style lang="less" scoped>
.timeAll {
    width: 390px;
    height: 80px;
    background: #FFFFFF;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-around;

    .left {
        padding: 0 20px;
        border-right: 1px solid #eee;
        color: #409eff ;

        div {
            text-align: center;
            line-height: 30px;
        }
    }

    .right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        text-align: center;
        align-items: center;

        .table_header {
            margin: 5px 15px;
            padding: 8px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #8e8e8e;
            cursor: pointer;
            background-color: #fff;
            border-radius: 5px;
            line-height: 25px;
        }

        .active {
            background-color: #409eff ;
            color: #fff;
        }
    }

    .week3 {
        width: 100px;
        font-size: 12px;
        padding: 5px;
        box-sizing: border-box;
        background-color: #eee;
        border-radius: 5px;
        cursor: pointer;

        div {
            text-align: center;
            margin-top: 3px;
        }
    }

    .week3-active {
        background: #409eff ;
        color: #fff;
    }
}
</style>